module.exports = __webpack_public_path__ + "static/media/varify-badge-step1.a4f0d4ea.png";